import React from 'react';
import PublicDocumentSubmit from '../../Applications/PublicDocumentSubmit';

/**
 * Public required-document upload for direct (manual) enrollments.
 * Reuses PublicDocumentSubmit patterns with enrollment APIs.
 */
const PublicEnrollmentDocumentSubmit = () => (
  <PublicDocumentSubmit entityType="enrollment" />
);

export default PublicEnrollmentDocumentSubmit;
